import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NavCollapseService } from '../../_services/nav-collapse.service';
import { UserProfileService } from '../../_services/user-profile.service';
import { UserProfile } from '../../_models/user-profile';
import { NavLinkAvailabilityService } from 'src/app/_services/nav-link-availability.service';
import { PortalApps } from 'src/app/_models/portal-routes';
import { ConfigurationService } from '../../_services/configuration.service';

@Component({
  selector: 'app-side-navbar',
  templateUrl: './side-navbar.component.html',
  styleUrls: ['./side-navbar.component.css']
})
export class SideNavbarComponent implements OnInit, OnDestroy {
  userProfile: UserProfile;
  isMinimized: boolean = false;
  availableAppLinks: PortalApps[] = [];
  portalVersion: string = '';
  // Subjects
  private onDestroy$ = new Subject<void>();

  constructor(
    private navCollapseService: NavCollapseService,
    private userService: UserProfileService,
    private navLinkService: NavLinkAvailabilityService,
    private configurationService: ConfigurationService,
    private router: Router
  ) {
    this.userService.userProfile$.pipe(takeUntil(this.onDestroy$)).subscribe(
      userProfile => { this.userProfile = userProfile });

    this.navLinkService.availableLinks$.pipe(takeUntil(this.onDestroy$)).subscribe(
      availableLinks => {
        this.availableAppLinks = availableLinks
      });
    this.configurationService.configData$.pipe(takeUntil(this.onDestroy$)).subscribe(
      configData => {
        this.portalVersion = configData.version
      }
    );
  }

  ngOnInit(): void {
  }

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  toggleIsMinimized() {
    this.isMinimized = !this.isMinimized;
    this.navCollapseService.updateIsMinimized(this.isMinimized);
  }

  onLogout() {
    this.router.navigate(['/logout']);
  }

  openUserPage() {
    if (this.checkURL()) {
      this.router.navigate(['/app/ControlPanel/users/user/' + this.userProfile.name]);
    }
  }

  checkURL(): boolean {
    return true;
  }
}
